import { ProgramAccommodationTypeEnum } from '@koob/enums';

type DayAccommodationStateKind =
  | 'bookedOnMyOwn'
  | 'hotelSelector'
  | 'nightTransfer'
  | 'noAccommodation';

export interface DayAccommodationState {
  kind: DayAccommodationStateKind;
  accommodationName?: string;
}

// A free-accommodation program needs a hotel until the user books it on their
// own: the day's `hotelBookedOnMyOwn` is only ever true, false or unset.
export function getDayAccommodationState({
  accommodationType,
  accommodationName,
  bookOnMyOwnValue,
}: {
  accommodationType: string | undefined;
  accommodationName: string | undefined;
  bookOnMyOwnValue: boolean | undefined;
}): DayAccommodationState {
  if (bookOnMyOwnValue === true) {
    return { kind: 'bookedOnMyOwn' };
  }

  const isExcludedType = [
    ProgramAccommodationTypeEnum.NIGHT_TRANSFER,
    ProgramAccommodationTypeEnum.NO_ACCOMMODATION,
    ProgramAccommodationTypeEnum.FREE_ACCOMMODATION,
  ].includes(accommodationType as any);
  const needsHotel =
    !isExcludedType ||
    (accommodationType === ProgramAccommodationTypeEnum.FREE_ACCOMMODATION &&
      !bookOnMyOwnValue);

  if (needsHotel) {
    return { kind: 'hotelSelector' };
  }

  if (accommodationType === ProgramAccommodationTypeEnum.NIGHT_TRANSFER) {
    return { kind: 'nightTransfer', accommodationName };
  }

  return { kind: 'noAccommodation' };
}
